<template>
    <div class="page">
        <div class="workspace">
            <div class="ws-unit">
                <div class="ws-unit-header ">
                    <div>
                        <el-button
                            type="primary"
                            size="small"
                            round
                            icon="el-icon-plus"
                            @click="create"
                        >添加</el-button>
                    </div>
                    <div class="ws-unit-toolbar">
                        <el-form inline>
                            <el-form-item>
                            <el-input
                                placeholder="请输入关键词"
                                v-model="filter.keyword"
                                clearable
                                @clear="onSearch()"
                                class="input-with-select"
                                size="mini"
                            >
                                <el-button
                                    slot="append"
                                    icon="el-icon-search"
                                    @click="onSearch()"
                                ></el-button>
                            </el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-radio-group
                                    v-model="filter.state"
                                    size="mini"
                                    @change="onSearch()"
                                >
                                    <el-radio-button label="所有"></el-radio-button>
                                    <el-radio-button label="已发布"></el-radio-button>
                                    <el-radio-button label="未发布"></el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="ws-unit-body">
                    <news-table ref="table" />
                </div>
            </div>
        </div>
        <news-form
            @success="onNewsSaveSuccess"
            ref="dialog"
        />
    </div>
</template>

<script>
import NewsTable from "./Table";
import NewsForm from "./Form";

export default {
    name: "News",
    components: {
        NewsTable,
        NewsForm
    },
    data: function() {
        return {
            filter: {
                state: "所有",
                keyword: null
            }
        };
    },
    methods: {
        create() {
            this.$refs.dialog.show();
        },
        onSearch() {
            this.$refs.table.loadData(1);
        },
        onNewsSaveSuccess() {
            this.$refs.table.loadData();
        }
    }
};
</script>

<style scoped>
</style>